import {Component, Input, Output, EventEmitter, ViewChild, OnInit, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import { ShellSideNavService } from '../../../shell/shell-sidenav.service';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
    selector: 'smp-modal',
    templateUrl: 'modal.component.html'
})
export class ModalComponent implements OnInit, AfterViewInit{
  @Input() modalClass: string;
  @Input() closeOnEscape: boolean = true;
  @Input() closeOnOutsideClick: boolean = true;
  @Input() title: string;
  @Input() hideCloseButton: boolean = false;
  @Input() cancelButtonLabel: string;
  @Input() submitButtonLabel: string;
  @Input() focusableInputId: string;
  @Input() allowOverflow: boolean = false;

  @Output() onOpen = new EventEmitter(false);
  @Output() onClose = new EventEmitter(false);
  @Output() onSubmit = new EventEmitter(false);

  @ViewChild('modalRoot') modalRoot: any;

  public mobileQuery: MediaQueryList;
  public modalConfig = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  private backdropElement: HTMLElement;
  private width: string = 'auto';
  public height: string = 'auto';
  public maxwidth: string = '';

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 900px)');
    this.mobileQuery.addListener(() => changeDetectorRef.detectChanges());
  }

  ngOnInit(){
  }

  ngAfterViewInit() {
    this.modalRoot.onHidden.subscribe(() => {
      this.onClose.emit();
    });
  }

  public open(...args: any[]) { 
    this.width = 'auto';
    this.height = 'auto';
    this.showModal(args);
  }

  public openWithCustomSize(args: any) {
    if (args) {
      this.setSize(args);
    }

    this.showModal(args);
  }

  public close(...args: any[]) {
    this.modalRoot.hide();
    this.onClose.emit(args);
  }

  private showModal(...args: any[]) {
    this.onOpen.emit(args);
    this.modalRoot.show();
  }

  private getModalWidth() {
    return {
      width: this.width
    };
  }

  private getModalMaxWidth() {
    return {
      max_width: this.maxwidth
    };
  }

  public preventClosing(event: MouseEvent) {
    event.stopPropagation();
  }

  private setSize(sizeData: any) {
    this.width = sizeData['width'] || 'auto';
    this.height = sizeData['height'] || 'auto';
    this.maxwidth = sizeData['maxwidth'] || '';
  }

  private getModalHeight() {
    return {
      height: this.height
    };
  }
}
